import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const DescriptionContainer = styled.div`
    white-space: pre-line;

    a {
        color: #008eff;
        text-decoration: none;
    }
`;

const CustomDescription = props => (
    <DescriptionContainer>
        <div
            dangerouslySetInnerHTML={{
                __html: props.description
            }}
        />
    </DescriptionContainer>
);
CustomDescription.propTypes = {
    description: PropTypes.string
};

export default CustomDescription;



// WEBPACK FOOTER //
// ./src/components/Overlay/CustomDescription.jsx